export class MapConstants {

  public static get SWITCH_COLOR(): string { return '#00C188'; };

}
